import { onMounted } from '@vue/composition-api';

const OfferName = ({ props, parent }) => {
    const { name, settings } = props;

    if (!name) {
        return;
    }

    let style = null;
    const classes = ['l-ss-c-offer-title'];

    if (settings?.maxLines) {
        style = {
            WebkitLineClamp: settings.maxLines,
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
        };
    }
    function isTextClipped(element) {
        if (!element) return false;

        // Проверяем, обрезается ли текст по вертикали (многострочное обрезание)
        if (element.scrollHeight > element.clientHeight) {
            return true;
        }

        // Проверяем, обрезается ли текст по горизонтали (однострочное обрезание)
        return element.scrollWidth > element.clientWidth;
    }

    if (settings?.tooltip) {
        onMounted(() => {
            const el = parent.$el;
            if (el) {
                const textBlock = el.querySelector('.l-ss-c-offer-title-text');
                if (textBlock && isTextClipped(textBlock)) {
                    el.classList.add('l-ss-c-data-tooltip');
                }
            }
        });
        return (
            <div class={classes.join(' ')} data-tooltip={name}>
                <div class="l-ss-c-offer-title-text" style={style}>
                    {name}
                </div>
            </div>
        );
    } else {
        return (
            <div class="l-ss-c-offer-title" style={style}>
                {name}
            </div>
        );
    }
};

OfferName.props = {
    name: {
        type: String,
    },
    settings: {
        type: Object,
    },
    offerItem: {
        type: Object,
    },
};

export default OfferName;
